import React, { useEffect, useState } from "react";
import { BottomLine } from "../../../components";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
  FaNodeJs,
  FaReact,
  FaGithub,
  FaGitAlt,
  FaFigma,
  FaSass,
} from "react-icons/fa";
import {
  SiJavascript,
  SiTailwindcss,
  SiExpress,
  SiFirebase,
  SiRedux,
  SiNextdotjs,
  SiTypescript,
  SiPostman,
  SiGraphql,
  SiMysql,
} from "react-icons/si";

// Import animations - EXACT SAME AS TESTIMONIAL
import { headingAnimation, sectionBodyAnimation } from "../../../hooks/useAnimation";

const MySkill = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [viewDiv, setViewDiv] = useState(false);
  const animation = useAnimation();

  useEffect(() => {
    if (inView) {
      setViewDiv(true);
    } else {
      setViewDiv(false);
    }
  }, [inView, animation]);

  // Skills divided into 3 lines
  const line1Skills = [
    // Line 1: 7 skills
    { title: "JavaScript", icon: <SiJavascript className="text-yellow-400" /> },
    { title: "TypeScript", icon: <SiTypescript className="text-blue-600" /> },    
    { title: "React", icon: <FaReact className="text-cyan-400" /> },
    { title: "Next.js", icon: <SiNextdotjs className="text-gray-100" /> },
    { title: "Redux", icon: <SiRedux className="text-violet-500" /> },
    { title: "Tailwind", icon: <SiTailwindcss className="text-cyan-300" /> },
    { title: "SASS", icon: <FaSass className="text-indigo-400" /> },
  ];

  const line2Skills = [
    // Line 2: 6 skills
    { title: "Node.js", icon: <FaNodeJs className="text-green-600" /> },
    { title: "Express.js", icon: <SiExpress className="text-gray-300" /> },
    { title: "MySQL", icon: <SiMysql className="text-blue-600" /> },
    { title: "Firebase", icon: <SiFirebase className="text-yellow-500" /> },
    { title: "GraphQL", icon: <SiGraphql className="text-indigo-500" /> },
    { title: "REST API", icon: <SiPostman className="text-orange-500" /> },
  ];

  const line3Skills = [
    // Line 3: Baaki 6 skills
    { title: "Git", icon: <FaGitAlt className="text-orange-600" /> },
    { title: "GitHub", icon: <FaGithub className="text-gray-200" /> },
    { title: "Figma", icon: <FaFigma className="text-violet-400" /> },
    // Add more if needed, currently 3 skills in line 3
  ];

  return (
    <div className="py-20 relative overflow-hidden bg-[#0c0a16] text-white">
      {/* EXACT SAME BACKGROUND AS TESTIMONIAL */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-gradient-to-r from-violet-600 to-indigo-600 blur-[100px] opacity-20 pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
      {/* EXACT SAME HEADING AS TESTIMONIAL */}
      <motion.div
        className="mb-12 relative z-10"
        initial="hidden"
        animate={viewDiv && "visible"}
        variants={headingAnimation}
      >
        
        <h1 className="text-4xl font-semibold text-center mb-3">
          My <span className="text-violet-400">Skills</span>
        </h1>
        <h3 className="text-center text-gray-400 text-lg tracking-wide">
          Technologies I Work With
        </h3>
        <BottomLine />
      </motion.div>

      {/* Skills Grid with same animation as testimonial */}
      <motion.div
        ref={ref}
        className="relative z-10"
        initial="hidden"
        animate={viewDiv && "visible"}
        variants={sectionBodyAnimation}
      >
        {/* Line 1: 7 skills */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-5 md:gap-6 max-w-5xl mx-auto mb-6 sm:mb-8">
          {line1Skills.map((skill) => (
            <motion.div
              key={skill.title}
              className="flex flex-col items-center justify-center p-3 sm:p-4 w-24 h-24 sm:w-28 sm:h-28
                         backdrop-blur-md bg-violet-900/20 border border-violet-500/10
                         rounded-2xl shadow-md hover:shadow-violet-500/30
                         cursor-pointer transition-all duration-300"
              title={skill.title}
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="text-3xl mb-2">{skill.icon}</div>
              <p className="text-sm text-center text-gray-200">{skill.title}</p>
            </motion.div>
          ))}
        </div>

        {/* Line 2: 6 skills */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-5 md:gap-6 max-w-5xl mx-auto mb-6 sm:mb-8">
          {line2Skills.map((skill) => (
            <motion.div
              key={skill.title}
              className="flex flex-col items-center justify-center p-3 sm:p-4 w-24 h-24 sm:w-28 sm:h-28
                         backdrop-blur-md bg-violet-900/20 border border-violet-500/10
                         rounded-2xl shadow-md hover:shadow-violet-500/30
                         cursor-pointer transition-all duration-300"
              title={skill.title}
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="text-3xl mb-2">{skill.icon}</div>
              <p className="text-sm text-center text-gray-200">{skill.title}</p>
            </motion.div>
          ))}
        </div>

        {/* Line 3: Baaki skills (center align for fewer items) */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-5 md:gap-6 max-w-5xl mx-auto">
          {line3Skills.map((skill) => (
            <motion.div
              key={skill.title}
              className="flex flex-col items-center justify-center p-3 sm:p-4 w-24 h-24 sm:w-28 sm:h-28
                         backdrop-blur-md bg-violet-900/20 border border-violet-500/10
                         rounded-2xl shadow-md hover:shadow-violet-500/30
                         cursor-pointer transition-all duration-300"
              title={skill.title}
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="text-3xl mb-2">{skill.icon}</div>
              <p className="text-sm text-center text-gray-200">{skill.title}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
      </div>
    </div>
  );
};

export default MySkill;